<template>
  <el-dialog
    :visible="visible"
    width="80%"
    top="5vh"
    @close="closeFn"
    title="批量添加设备"
    >
    <div class="overflow margin_bottom">
        <div class="fl overflow input_val">
          <span class="fl">所属组织:</span>
          <TreeSelect
            v-model="organization"
            :data="treeData"
            :props="defaultProps"
            node-key="organizationId"
            class="w_160 fl"
            icon="icon-truckgroup"
            :disabled="type === 'update'?true:false"
          />
        </div>
        <el-button type="primary" class="fl" @click="inputData">录入数据</el-button>
        <el-button type="primary" class="fr" @click="DownloadTemplate">下载模板</el-button>
    </div>
    <el-table
        v-loading="loading"
        ref="table"
        :data="tableData"
        border
        height="60vh"
        size="mini"
        style="width: 100%"
        row-key="vehicleId"
        :cell-style="rowClassName">
        <el-table-column
          width="240"
          label="错误提示"
          prop="errorRemark"
        />
        <el-table-column
          width="160"
          label="电池编号"
          prop="bmsNo">
          <template #default="{row}">
            <el-input
              size="small"
              class="w120"
              v-model.trim="row.bmsNo"
              autocomplete="off"
              v-if="row.edit"
            />
            <span v-else>
              {{row.bmsNo}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          label="电池类型"
          prop="bmsNo">
          <template #default="{row}">
            <el-select
              class="w140"
              v-model="row.bmsType"
              placeholder="请选择"
              v-if="row.edit"
            >
              <el-option
                v-for="item in bmsTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-else>
              {{row.bmsType}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          label="设备号"
          prop="bmsNo">
          <template #default="{row}">
            <el-input
              size="small"
              class="w140"
              v-model.trim="row.terminalNo"
              autocomplete="off"
              v-if="row.edit"
            />
            <span v-else>
              {{row.terminalNo}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="240"
          label="安装时间"
          prop="bmsNo">
          <template #default="{row}">
            <el-date-picker
                v-model="row.doDate"
                type="datetime"
                class="w200"
                placeholder="选择日期时间"
                default-time="00:00:00"
                value-format="yyyy-MM-dd hh:mm:ss"
                v-if="row.edit"
              >
              </el-date-picker>
            <span v-else>
              {{row.doDate}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="设备类型"
          prop="bmsNo">
          <template #default="{row}">
            <el-select
              class="w160"
              v-model="row.terminalType"
              placeholder="请选择"
              v-if="row.edit"
            >
              <el-option
                v-for="item in terminalTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-else>
              {{row.terminalType}}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="180"
          label="服务密码"
          prop="bmsNo">
          <template #default="{row}">
            <el-input
                size="small"
                class="w140"
                v-model.trim="row.serviceCode"
                autocomplete="off"
                maxlength="10"
                v-if="row.edit"
              />
            <span v-else>
              {{row.serviceCode}}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="SIM卡号"
          width="180"
          prop="bmsNo">
          <template #default="{row}">
            <el-input
              size="small"
              class="w140"
              v-model.trim="row.sim"
              autocomplete="off"
              maxlength="13"
              v-if="row.edit"
            />
            <span v-else>
              {{row.sim}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="安装备注"
          width="180"
          prop="bmsNo">
          <template #default="{row}">
            <el-input
              size="small"
              class="w140"
              v-model.trim="row.installRemark"
              autocomplete="off"
              v-if="row.edit"
            />
            <span v-else>
              {{row.installRemark}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          prop="bmsNo"
        >
          <template #default="{row}">
            <el-button size="mini" @click="row.edit=!row.edit;row.operatorType = 1">{{row.edit?'保存':'修改'}}</el-button>
            <el-button size="mini" @click="row.operatorType = 2;deleteData(row);">删除</el-button>
          </template>
        </el-table-column>
    </el-table>
    <div class="overflow margin_top">
      <el-button type="primary" class="fr" v-if="tableData.length > 0" @click="setEditData">提交修改</el-button>
      <el-upload
        class="up_btn fr"
        action=""
        :http-request="({ file }) => (excelFile = file)"
        :show-file-list="false"
        :on-change="onChange"
      >
        <div
        class="el-upload__text"
        v-html="excelFile?`<el-button type='primary'>重新上传</el-button>`:`<el-button type='primary'>上传</el-button>`"></div>
      </el-upload>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import { toTreeData } from "@/assets/js/base";
import TreeSelect from "@/components/TreeSelect/index.vue";
export default {
  name:'batchAdd',
  components:{
    TreeSelect
  },
  data(){
    return {
      loading:false,
      organization:null,
      defaultProps: {
        children: "children",
        label: "organizationName"
      },
      type:'',
      excelFile:null,
      visible:false,
      tableData:[],
      terminalTypeOptions: [
        {
          value: "GPRS-XINGHENG",
          label: "GPRS-XINGHENG"
        },
        {
          value: "GPRS-BETTER",
          label: "GPRS-BETTER"
        },
        {
          value: "GPRS-PEICHENG",
          label: "GPRS-PEICHENG"
        },
        {
          value: "GPRS-DALI",
          label: "GPRS-DALI"
        },
        {
          value: "GPRS-HERCULES",
          label: "GPRS-HERCULES"
        },
        {
          value: "LD-01A",
          label: "LD-01A"
        },
        {
          value: "GPRS-SUNWODA",
          label: "GPRS-SUNWODA"
        }
      ],
      bmsTypeOptions: [
        {
          value: "三元锂电池",
          label: "三元锂电池"
        },
        {
          value: "磷酸铁锂电池",
          label: "磷酸铁锂电池"
        },
        {
          value: "锰酸锂电池",
          label: "锰酸锂电池"
        }
      ],
      delData:[],//存储删除数据
    }
  },
  computed:{
    ...mapState(["GROUPLIST","USER"]),
    treeData() {
      return toTreeData(this.GROUPLIST, {
        id: "organizationId",
        parentId: "parentId"
      });
    },
  },
  methods:{
    //关闭弹框
    closeFn(){
      this.tableData = [];
      this.delData = [];
      this.organization = null;
      this.excelFile = null;
      this.loading = false;
      this.visible = false;
    },
    //下载模板
    DownloadTemplate(){
      window.open('/api/vehicle/downLoadBatchTemplate.json');
    },
    //录入数据
    inputData(){
      let onoff = this.tableData.some(item=>item.statusFlag==2);
      try{
        if(!this.tableData.length) throw{msg:'请上传数据'};
        if(onoff) throw{msg:'当前数据存在不正确数据，请修改后录入'};
        if(!this.organization) throw{msg:'请选择所属组织'};
        this.loading = true;
        this.$API.batchAddVehicle({groupId:this.organization.organizationId}).then(res=>{
          this.$msg({
            type:res.code == 0?'success':'warning',
            message:res.msg
          })
          if(res.code == 0){
            this.$API.clearImportTemp();//清空缓存数据
            this.tableData = [];
            this.delData = [];
            this.loading = false;
          }
        }).catch(error=>{
          console.log(error);
        })
      }catch(error){
        console.log(error);
        this.$msg({
          type:'warning',
          message:error.msg
        })
      }
    },
    //提交修改信息
    setEditData(){
      if(this.tableData.length+this.delData.length == 0)return;
      let array = this.tableData.concat(this.delData);
      let arr = array.map(item=>{
        delete item.edit;
        delete item.errorRemark
        return {
          ...item
        }
      });
      this.loading = true;
      this.$API.updateErrorInfo(arr).then(res=>{
        this.$API.getVehicleImportTemp().then(rst=>{
          this.loading = false;
          this.tableData = rst.data.map(item=>{
            return {
              ...item,
              edit:false,
              operatorType:1
            }
          })
        }).catch(error=>{
          console.log(error);
        })
      }).catch(error=>{
        console.log(error)
      })
    },
    //加背景颜色
    rowClassName(row){
      return row.row.statusFlag == 2?'background: #F56C6C;color:#FFF;':'';
    },
    //查询数据
    getData(onoff){
      let self = this;
      this.loading = true;
      this.$API.getVehicleImportTemp().then(res=>{
        if(res.data.length && onoff){
          self.$msgBox.confirm('缓存数据中存在数据，是否重新上传?', '提示', {
            confirmButtonText: '重新上传',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(res=>{
            //清楚缓存数据
            this.$API.clearImportTemp().then(res=>{
              res.code == 0 && this.updateFile();
            })
          }).catch(error=>{//使用缓存数据
            this.loading = false;
            this.tableData = res.data.map(item=>{
              // item.doDate = this.regTime(item.doDate);
              return {
                ...item,
                edit:false,
                operatorType:1
              }
            });
          })
        }else{
          this.updateFile();
        }
      }).catch(error=>{
        console.log(error);
      })
    },
    //先查询之前数据是否清空
    onChange(){
      this.getData(true);
    },
    //检测是否为时间格式
    regTime(str){
      return /^\d{4}-\d{2}-\d{2}$/.test(str)?str:'';
    },
    //上传文件
    updateFile(){
      let formData = new FormData();
      formData.append('file',this.excelFile);
      this.$API.importVehicleExcel(formData).then(res=>{
        console.log(res);
        if(res.code == 0){
          this.$API.getVehicleImportTemp().then(res=>{
            this.tableData = res.data.map(item=>{
              // item.doDate = this.regTime(item.doDate);
              return {
                ...item,
                edit:false,
                operatorType:1
              }
            });
            this.loading = false;
          }).catch(error=>{
            console.log(error);
          })
        }
      }).catch(error=>{
        console.log(error);
      })
    },
    //删除数据
    deleteData(row){
      console.log(row);
      this.tableData = this.tableData.filter(item=>item.operatorType != 2);
      this.delData.push(row);
      console.log(this.delData)
    }
  }
}
</script>
<style scoped>
.up_btn .el-upload{
  width: 100%;
}
.up_btn .el-upload__text{
  color:#FFF;
  width: 120px;
}
</style>
<style lang="scss" scoped>
.overflow{
  overflow: hidden;
}
.w_160{
  width: 160px;
}
.margin_top{
  margin-top: 10px;
}
.fl{
  float: left;
}
.fr{
  float: right !important;
}
.input_val{
  line-height: 40px;
  margin-left: 10px;
  span{
    display:inline-block;
    margin-right: 10px;
  }
}
.margin_bottom{
  margin-bottom:10px;
}
.up_btn{
  text-align: center;
  width:120px;
  float:left;
  line-height: 40px;
  border-radius: 6px;
  margin-right: 10px;
  color:#FFF;
  background: #00D3B8;
  .el-upload:active{
    color:#FFF;
  }
}
</style>
